/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import Vue from 'vue'
import Component from 'vue-class-component'
import {HTTPService} from '@/services/HTTPService'

@Component
export default class HTTPServiceMixin extends Vue {
    public httpService: HTTPService = new HTTPService(
        (isLoading: boolean) => this.$store.commit('setIsLoading', isLoading),
    )
}
